<template>

<div>
 <!-- SIDE BAR SECTION -->
 <div class="fixed z-50">
      <sideBar/>
    </div>


  <nav class="sticky w-full z-40 top-0 " >

        <navBar/>

  </nav>


  <!-- DASHBOARD -->

  <div class="flex bg-[#e8e6fe] w-full pb-12 relative">


    <!-- DASHBOARD CONTENT -->

  <div class=" mt-2 w-full mx-10 ml-72">

    <div class="flex flex-row justify-between items-center">
      
        <div class="text-black text-center font-euclid font-medium text-lg">
          <h1>Latest Reminder</h1>
        </div>

    
        <div v-if="!verifyStatus" class="text-white   font-euclid font-semibold text-base">
         <button @click="unverifyAlert" class="py-2 px-3 bg-gray-400 rounded-xl">Add Reminder</button>
        </div>

        <div v-else class="text-white  flex  font-euclid font-medium text-base ">
        <router-link to="/add-reminder"> <button  class="py-2 px-4 rounded-xl border-2 bg-medalertBlue border-medalertBlue text-white hover:bg-blueHover hover:text-white ">Add Reminder</button></router-link>
        </div>

    </div>

    <div  class="flex justify-center content-center items-center align-middle w-full" v-if="isLoading">
      <Loader />
    </div>

    <div class="flex justify-between">
      
      <!-- LATEST REMINDER -->
      <div class=" flex flex-col w-5/6 h-auto font-euclid">


          <!-- EMPTY STATE -->
        <div v-if="allReminders.length == 0" class=" flex flex-col bg-white px-20 py-60 w-full mt-10 h-4/5 rounded-md justify-center items-center text-center">
            <i class="ri-notification-off-line text-4xl text-gray-400"></i>
            <h1 class="text-gray-500">You have not created any <br>reminder yet</h1>
        </div>

        <ul>
          <li v-for="(reminder,index) in allReminders.slice(0,5)" :key="index">
            <div class="bg-white rounded-sm h-auto  w-full mx-auto mt-8  ">
              <div class=" flex justify-between bg-gray-100 w-full py-1 px-6 align-middle content-center text-center items-center">
                <div class="flex">
                  <h1 class=" text-medalertBlue my-auto font-medium mr-2">{{reminder.phone_number}}</h1> 
                  <!-- <div  class="cursor-pointer"> 
                    <span class=" bg-medalertOrange text-white hover:text-white hover:bg-redHover  rounded py-1 px-2 text-xs" v-if="!reminder.suspended" > <button @click.prevent="stopReminder(reminder.id)"> Suspend </button></span> <span v-else class=" bg-medalertBlue text-white hover:text-white  hover:bg-blueHover  rounded py-1 px-2 text-xs "> <button @click.prevent="resumeReminder(reminder.id)"> Resume </button></span> 
                  </div> -->
                </div>

                <!-- <div class="text-sm text-center font-normal">
                  <h1>Created By: {{reminder.created_by}}</h1>
                </div> -->

                <div class="flex my-auto justify-between w-4/12">
                  <div class="tooltip">
                    <i  class="ri-alarm-warning-line text-lg text-black"> <span class="font-euclid font-medium text-sm align-middle">{{reminder.total_number_of_reminder}}</span></i>
                    <span class="tooltiptext">Total SMS</span>
                  </div>

                  <div class="tooltip">
                    <i class="ri-check-double-fill text-lg text-medalertBlue   "><span class="font-euclid font-medium text-sm align-middle ">{{reminder.no_of_sent_reminder}}</span></i>
                    <span class="tooltiptext">Sent SMS</span>
                  </div>

                  <div class="tooltip">
                    <i class="ri-time-line text-lg text-medalertOrange "><span class="font-euclid font-medium text-sm align-middle">{{reminder.total_number_of_reminder - reminder.no_of_sent_reminder}}</span></i>
                    <span class="tooltiptext">Pending SMS</span>
                  </div>

                  <div  class="cursor-pointer"> 
                      <span class=" " v-if="!reminder.suspended" > <button class="disabled:bg-gray-300 bg-medalertOrange text-white hover:text-white hover:bg-redHover  rounded py-1 px-2 text-xs "
                        :disabled="reminder.total_number_of_reminder - reminder.no_of_sent_reminder ===0"
                        :class="reminder.total_number_of_reminder - reminder.no_of_sent_reminder ===0 ? 'cursor-not-allowed' : ''"
                         @click.prevent="stopReminder(reminder.id)"> Suspend </button></span> <span v-else class=""> <button class="disabled:bg-gray-300  bg-medalertBlue text-white hover:text-white  hover:bg-blueHover  rounded py-1 px-2 text-xs " @click.prevent="resumeReminder(reminder.id)"> Resume </button></span> 
                  </div>

                </div>
              </div>
              <!-- <div class="py-2 px-6 text-left text-black text-sm tracking-wide"
              v-for="(prescription, index) in reminder.items" :key="index">
                <p> {{prescription.drug_name}} , <span>{{prescription.dose}}</span>  x <span>{{prescription.no_of_days}} Days</span>, <span class="ml-4"> Starting: {{prescription.start_time}} </span>
                </p>
              </div> -->
            
              <div class="py-2 px-6 text-left text-black text-sm tracking-wide">
                <table class="table w-full text-left mx-auto rounded-md table-auto">
                  <thead class="bg-gray-200 py-2 font-light rounded-md">
                    <tr>
                    </tr>
                  </thead>
                    <tbody class="">
                      <tr v-for="(prescription, index) in reminder.items" :key="index" class="">
                        <td>{{prescription.drug_name}}</td>
                        <td> <span v-if="prescription.dose">{{prescription.dose}}</span> <span v-else>None</span> </td>
                        <td>x {{prescription.no_of_days}} Days</td>
                        <td> Starting: {{ new Date(prescription.start_time).toLocaleDateString()}}</td>
                      </tr>
                      <tr class="">
                        <div class=" pt-3  text-xs font-normal bg-white ">
                          <h1>Created By: {{reminder.created_by}}</h1>
                        </div>
                      </tr>
                    </tbody>
                </table>
              </div>

            </div>
            
          </li>
        </ul>
        
      </div>

      <!-- REMINDER STATISTIC -->
      <div class="flex flex-col w-2/6 ml-14 mt-6 ">

      <div class=" flex  flex-row w-full  h-40  mx-auto py-2 font-euclid">

        <div class="bg-white w-full flex flex-col justify-center rounded-lg">
          <span v-if="isLoading">
            <Loading />
          </span> 
          <span v-if="!isLoading" > <h1 class="text-medalertBlue  font-medium text-2xl">{{user.units_remaining}}</h1> </span>
            <p class="text-black font-medium text-base mt-1">Units Remaining</p>
        </div>
      </div>

        <div class=" flex  flex-row w-full  h-40  mx-auto py-2 font-euclid">

          <div class="bg-white w-full flex flex-col justify-center rounded-lg">
            <span v-if="isLoading">
              <Loading />
            </span> 
            <span v-if="!isLoading" > <h1 class="text-black  font-medium text-2xl">{{totalReminders}}</h1> </span>
              <p class="text-black font-medium text-base mt-1">Total Reminders</p>
          </div>
          <!-- <div class="bg-black w-2"></div> -->
        </div>
        
        <div class=" flex  flex-row w-full  h-40 mt-3 py-2 font-euclid">

          <div class="bg-white w-full flex flex-col justify-center rounded-lg">
            <span v-if="isLoading">
              <Loading />
            </span> 
            <span v-if="!isLoading" > <h1 class="text-medalertBlue  font-medium text-2xl">{{sentReminders}}</h1> </span>
              <p class="text-black font-medium text-base mt-1">Sent Reminders</p>
          </div>
          <!-- <div class=" bg-medalertBlue w-2"></div> -->
        </div>

        <div class=" flex  flex-row w-full  h-40 mt-3 py-2 font-euclid">

          <div class="bg-white w-full flex flex-col justify-center rounded-lg">
            <span v-if="isLoading">
              <Loading/>
            </span> 
            <span v-if="!isLoading" > <h1 class="text-medalertOrange  font-medium text-2xl">{{pendingReminders}}</h1> </span>
              <p class="text-black font-medium text-base mt-1">Pending Reminders</p>
          </div>
          <!-- <div class=" bg-medalertOrange w-2"></div> -->

        </div>

      </div>
      

    </div>

  </div>

  </div>

    
</div>
</template>



<script>

import navBar from '../components/NavBar'
import sideBar from '../components/SideBar'
import axios from 'axios';
import Loader from "../components/Loader";
import Loading from "../components/Loading";

import { ref } from 'vue'
import {useRouter} from 'vue-router'
import { useStore } from "vuex";


export default {

  components:{navBar, sideBar, Loader, Loading},

  setup(){
    const store = useStore();
    const user = store.state.user
    const router = useRouter()
    const isLoading = ref(false);

    const verifyStatus = store.state.user.client.is_verified

    const success = ref("");
    const err = ref("");
    // isSuspended = ref(false)

    const allReminders = ref([]);
    console.log(allReminders)



    const totalReminders = ref(null);
    const sentReminders = ref(null);
    const pendingReminders = ref(null);

    const unverifyAlert = async () => {
      alert('Your account have not been verified. We will verify you soon')
    }


    const reminderRecords = async () =>{
      try{
        isLoading.value = true;
        const response = await axios.get(`/api/v1/prescriptions/approved?page-number=1&limit=10`)
        let reminders = response.data.data.data
        console.log(reminders)
        allReminders.value = reminders
      
        isLoading.value = false;
      } catch(error){
        err.value = error.response?.data?.result?.message ?? "Erorr! could not fetch reminder record";
      }
    }
    

    const stopReminder = async (id) =>{
      try{
        const response = await axios.patch(`/api/v1/prescriptions/${id}/suspend`)
        if (response){
          // isSuspended.value = true
          let feedback =  response.data.result.message
          alert(feedback)
        } reminderRecords()
      } catch(error){
        err.value = error.response?.data?.result?.message ?? "Erorr! could not suspend reminder";
      }
    }

    const resumeReminder = async (id) =>{
      try{
        const response = await axios.patch(`/api/v1/prescriptions/${id}/resume`)
        if (response){
          let feedback =  response.data.result.message
          alert(feedback)
        } reminderRecords()
      } catch(error){
        err.value = error.response?.data?.result?.message ?? "Erorr! could not resume reminder";
      }
    }

    const clientMetrics = async()=>{
      try{
        const response = await axios.get('/api/v1/clients/metric')
        const getMetrics = response.data.data
        totalReminders.value = getMetrics.total_reminder
        sentReminders.value = getMetrics.total_reminder_sent
        pendingReminders.value = getMetrics.total_reminder_pending
        console.log(response)
      }catch(error){
        console.log(error)
      }
    }



    return{
        user,
        success,
        err,
        allReminders,
        verifyStatus,
        isLoading,
        sentReminders,
        pendingReminders,
        totalReminders,
        reminderRecords,
        stopReminder,
        resumeReminder,
        unverifyAlert,
        clientMetrics,
        
      }

  },

  mounted(){
      this.reminderRecords();
      this.clientMetrics();
    }

 

}
</script>



<style>

.tooltip {
  position: relative;
  display: inline-block;
  opacity: 2;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 80px;
  background-color: #DCD0FF;
  opacity: 2;
  color: black;
  text-align: center;
  border-radius: 2px;
  padding: 2px 0px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  font-size: small;
}

</style>